import { getField, updateField } from 'vuex-map-fields'
import moment from 'moment'
import { prepareUrl, uri } from '~/api/uri'

export const initState = {
  turnover: [],
  turnoverTime: null,
  clientTotals: [],
  clientTotalsTime: null,
  twoDaysTotal: {},
  twoDaysChart: {},
  sevenDaysTotal: {},
  sevenDaysChart: {},
  thirtyDaysTotal: {},
  thirtyDaysChart: {},
  /**
   * BASE CHARTS
   */
  baseFreeUnlocked: {
    options: {
      from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      coutry_id: 0
    },
    filter: {
      countries: []
    },
    chart: [],
    avg: []
  },
  baseRevenue: {
    options: {
      from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      coutry_id: 0
    },
    filter: {
      countries: []
    },
    chart: [],
    avg: []
  },
  baseHostessDeleted: {
    options: {
      from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      coutry_id: 0
    },
    filter: {
      countries: []
    },
    chart: [],
    avg: []
  },
  baseHostessValidated: {
    options: {
      from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      coutry_id: 0
    },
    filter: {
      countries: []
    },
    chart: [],
    avg: []
  },
  basePrimeHistory: {
    options: {
      from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      coutry_id: 0
    },
    filter: {
      countries: []
    },
    chart: {
      client: [],
      hostess: []
    },
    avg: []
  },
  baseCreditHistory: {
    options: {
      from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      coutry_id: 0
    },
    filter: {
      countries: []
    },
    chart: {
      credits: [],
      bonus: []
    },
    avg: []
  },
  baseHostessCancelledToValidated: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0
    },
    filter: {
      countries: []
    },
    chart: {
      percent: [],
      cancelled: [],
      validated: []
    },
    avg: []
  },
  baseClientLeave: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0,
      selected: 'all'
    },
    filter: {
      countries: []
    },
    chart: [],
    items: []
  },
  baseHostessLeave: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0,
      selected: 'all'
    },
    filter: {
      countries: []
    },
    chart: [],
    items: []
  },
  /**
   * USER STAT CHARTS
   */
  userStatConfirmed: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0,
      user_type: '',
      campaign: ''
    },
    filter: {
      countries: [],
      campaigns: []
    },
    chart: [],
    avg: []
  },
  userStatFreeLikes: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0,
      user_type: 'client',
      campaign: ''
    },
    filter: {
      countries: [],
      campaigns: []
    },
    chart: [],
    avg: []
  },
  userStatPerspective: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0,
      user_type: 'client',
      campaign: ''
    },
    filter: {
      countries: [],
      campaigns: []
    },
    chart: [],
    avg: []
  },
  userStatKpiClients: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0,
      user_type: 'client',
      campaign: ''
    },
    filter: {
      countries: [],
      campaigns: []
    },
    chart: {
      tot: [],
      d10: []
    },
    avg: []
  },
  userStatKpiHostess: {
    options: {
      from: undefined,
      to: undefined,
      coutry_id: 0,
      user_type: 'hostess',
      campaign: ''
    },
    filter: {
      countries: [],
      campaigns: []
    },
    chart: {
      tot: [],
      h10: []
    },
    avg: []
  },
  userStatLids: {
    options: {
      from: undefined,
      to: undefined
    },
    filter: {
      countries: [],
      campaigns: []
    },
    chart: {
      lids: [],
      conv: []
    }
  }
}

export const state = () => {
  return {
    ...initState
  }
}

function formatCredits (value) {
  // format number to Euro
  const credits = Intl.NumberFormat('de-DE', {
    maximumFractionDigits: 0
  })
  return credits.format(value || 0)
}
function formatFloat (value) {
  // format number to Euro
  const credits = Intl.NumberFormat('de-DE', {
    maximumFractionDigits: 2
  })
  return credits.format(value || 0)
}
function formatCurrency (value, currencySign = '$') {
  // format number to Euro
  const curr = Intl.NumberFormat('de-DE', {
    style: 'decimal',
    useGrouping: 'always',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  })
  return `${currencySign}${curr.format(Math.round(parseFloat(value || '0')))}`
}
function prepareTotalsData (value, currencySign = '$') {
  value.data.amount = formatCurrency(value?.data?.amount || 0, currencySign)
  value.data.credits = formatCredits(value?.data?.credits || 0, currencySign)
  return value
}
function prepareChartData (value, currencySign = '$') {
  if (value?.data?.credits?.length) {
    value.data.credits = value.data.credits
      .map((i) => {
        i.l = formatCredits(i.y)
        return i
      })
  }
  if (value?.data?.revenue?.length) {
    value.data.revenue = value.data.revenue
      .map((i) => {
        i.l = formatCurrency(i.y, currencySign)
        return i
      })
  }
  if (value?.data?.spent?.length) {
    value.data.spent = value.data.spent
      .map((i) => {
        i.l = formatCredits(i.y)
        return i
      })
  }
  return value
}
function prepareTurnoverData (value, currencySign = '$') {
  if (value?.length) {
    value = value
      .map((i) => {
        i.credits = formatCredits(i.credits)
        i.records_count = formatCredits(i.records_count)
        i.display_amount = formatCurrency(i.amount, currencySign)
        return i
      })
  }
  return value
}
function prepareClientTotalsData (value) {
  if (value) {
    value.clients_total = formatCredits(value.clients_total)
    value.credits_total = formatCredits(value.credits_total)
    value.credits_avg = formatFloat(value.credits_avg)
  }
  return value
}

export const actions = {
  async loadTurnover ({ commit }) {
    const res = await this.$axios(uri.dashboard.turnover)
    if (res.data && res.data.data) {
      commit('setTurnover', res.data)
    }
  },
  async updateTurnover ({ commit }) {
    const res = await this.$axios.$post(uri.dashboard.turnover)
    if (res.data && res.data.data) {
      commit('setTurnover', res.data)
    }
  },
  async loadClientTotals ({ commit }) {
    const res = await this.$axios(uri.dashboard.clientTotals)
    if (res.data && res.data.data) {
      commit('setClientTotals', res.data)
    }
  },
  async sevenDaysTotal ({ commit }) {
    const res = await this.$axios(uri.dashboard.sevenDaysTotal)
    if (res.data) {
      commit('setSevenDaysTotal', res.data)
    }
  },
  async sevenDaysChart ({ commit }) {
    const res = await this.$axios(uri.dashboard.sevenDaysChart)
    if (res.data) {
      commit('setSevenDaysChart', res.data)
    }
  },
  async sevenDaysUpdate () {
    await this.$axios.$post(uri.dashboard.sevenDays)
  },
  async thirtyDaysTotal ({ commit }) {
    const res = await this.$axios(uri.dashboard.thirtyDaysTotal)
    if (res.data) {
      commit('setThirtyDaysTotal', res.data)
    }
  },
  async thirtyDaysChart ({ commit }) {
    const res = await this.$axios(uri.dashboard.thirtyDaysChart)
    if (res.data) {
      commit('setThirtyDaysChart', res.data)
    }
  },
  async thirtyDaysUpdate () {
    await this.$axios.$post(uri.dashboard.thirtyDays)
  },
  async monthlyTotal ({ commit }, { year, month }) {
    const res = await this.$axios(prepareUrl(uri.dashboard.monthlyTotal, { year, month }))
    if (res.data) {
      commit('setMonthlyTotal', { year, month, data: res.data })
    }
  },
  async monthlyChart ({ commit }, { year, month }) {
    const res = await this.$axios(prepareUrl(uri.dashboard.monthlyChart, { year, month }))
    if (res.data) {
      commit('setMonthlyChart', { year, month, data: res.data })
    }
  },
  async monthlyUpdate ({ commit }, { year, month }) {
    await this.$axios.$post(prepareUrl(uri.dashboard.monthly, { year, month }))
  },

  /**
   * BASE CHARTS
   */
  async loadFreeUnlocked ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.baseFreeUnlocked, {
      params: options || state.baseFreeUnlocked.options || {}
    })
    if (res.data) {
      commit('setFreeUnlocked', res.data)
    }
  },
  async loadBaseRevenue ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.baseRevenue, {
      params: options || state.baseRevenue.options || {}
    })
    if (res.data) {
      commit('setRevenue', res.data)
    }
  },
  async loadHostessDeleted ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.baseHostessDeleted, {
      params: options || state.baseHostessDeleted.options || {}
    })
    if (res.data) {
      commit('setHostessDeleted', res.data)
    }
  },
  async loadHostessValidated ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.baseHostessValidated, {
      params: options || state.baseHostessValidated.options || {}
    })
    if (res.data) {
      commit('setHostessValidated', res.data)
    }
  },
  async loadPrimeHistory ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.basePrimeHistory, {
      params: options || state.basePrimeHistory.options || {}
    })
    if (res.data) {
      commit('setPrimeHistory', res.data)
    }
  },
  async loadCreditHistory ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.baseCreditHistory, {
      params: options || state.baseCreditHistory.options || {}
    })
    if (res.data) {
      commit('setCreditHistory', res.data)
    }
  },
  async loadHostessCancelledToValidated ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.baseHostessCancelledToValidated, {
      params: options || state.baseHostessCancelledToValidated.options || {}
    })
    if (res.data) {
      commit('setHostessCancelledToValidated', res.data)
    }
  },
  async loadClientLeave ({ commit, state }, options) {
    const url = prepareUrl(uri.dashboard.baseUserLeaveChart, { user_type: 'client' })
    const res = await this.$axios(url, {
      params: options || state.baseClientLeave.options || {}
    })
    if (res.data) {
      commit('setClientLeave', res.data)
    }
  },
  async loadHostessLeave ({ commit, state }, options) {
    const url = prepareUrl(uri.dashboard.baseUserLeaveChart, { user_type: 'hostess' })
    const res = await this.$axios(url, {
      params: options || state.baseHostessLeave.options || {}
    })
    if (res.data) {
      commit('setHostessLeave', res.data)
    }
  },
  async loadClientLeaveItems ({ commit, state }, options) {
    const url = prepareUrl(uri.dashboard.baseUserLeaveItems, {
      user_type: 'client',
      option_key: options?.selected || 'all'
    })
    const res = await this.$axios(url, {
      params: options || state.baseClientLeave.options || {}
    })
    if (res.data) {
      commit('setClientLeaveItems', res.data)
    }
  },
  async loadHostessLeaveItems ({ commit, state }, options) {
    const url = prepareUrl(uri.dashboard.baseUserLeaveItems, {
      user_type: 'hostess',
      option_key: options?.selected || 'all'
    })
    const res = await this.$axios(url, {
      params: options || state.baseHostessLeave.options || {}
    })
    if (res.data) {
      commit('setHostessLeaveItems', res.data)
    }
  },
  /**
   * USERS STAT
  */
  async loadUserStatCofirmed ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.userStatConfirmed, {
      params: options || state.userStatConfirmed.options || {}
    })
    if (res.data) {
      commit('setUserStatConfirmed', res.data)
    }
  },
  async loadUserStatFreeLikes ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.userStatFreeLikes, {
      params: options || state.userStatFreeLikes.options || {}
    })
    if (res.data) {
      commit('setUserStatFreeLikes', res.data)
    }
  },
  async loadUserStatPerspective ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.userStatPerspective, {
      params: options || state.userStatFreeLikes.options || {}
    })
    if (res.data) {
      commit('setUserStatPerspective', res.data)
    }
  },
  async loadKpiClients ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.userStatKpiClients, {
      params: options || state.userStatKpiClients.options || {}
    })
    if (res.data) {
      commit('setUserStatKpiClients', res.data)
    }
  },
  async loadKpiHostess ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.userStatKpiHostess, {
      params: options || state.userStatKpiHostess.options || {}
    })
    if (res.data) {
      commit('setUserStatKpiHostess', res.data)
    }
  },
  async loadUserStatLids ({ commit, state }, options) {
    const res = await this.$axios(uri.dashboard.userStatLids, {
      params: options || state.userStatLids.options || {}
    })
    if (res.data) {
      commit('setUserStatLids', res.data)
    }
  }
}

export const mutations = {
  updateField,
  setFreeUnlocked (state, data) {
    state.baseFreeUnlocked.chart = data?.chart || []
    state.baseFreeUnlocked.avg = data?.avg || []
    state.baseFreeUnlocked.options = data?.options || {}
    state.baseFreeUnlocked.filter.countries = data?.filter?.countries || []
  },
  setRevenue (state, data) {
    state.baseRevenue.chart = data?.chart || []
    state.baseRevenue.avg = data?.avg || []
    state.baseRevenue.options = data?.options || {}
    state.baseRevenue.filter.countries = data?.filter?.countries || []
  },
  setHostessDeleted (state, data) {
    state.baseHostessDeleted.chart = data?.chart || []
    state.baseHostessDeleted.avg = data?.avg || []
    state.baseHostessDeleted.options = data?.options || {}
    state.baseHostessDeleted.filter.countries = data?.filter?.countries || []
  },
  setHostessValidated (state, data) {
    state.baseHostessValidated.chart = data?.chart || []
    state.baseHostessValidated.avg = data?.avg || []
    state.baseHostessValidated.options = data?.options || {}
    state.baseHostessValidated.filter.countries = data?.filter?.countries || []
  },
  setPrimeHistory (state, data) {
    state.basePrimeHistory.chart.client = data?.chart?.client || []
    state.basePrimeHistory.chart.hostess = data?.chart?.hostess || []
    state.basePrimeHistory.avg = data?.avg || []
    state.basePrimeHistory.options = data?.options || {}
    state.basePrimeHistory.filter.countries = data?.filter?.countries || []
  },
  setCreditHistory (state, data) {
    state.baseCreditHistory.chart.credits = data?.chart?.credits || []
    state.baseCreditHistory.chart.bonus = data?.chart?.bonus || []
    state.baseCreditHistory.avg = data?.avg || []
    state.baseCreditHistory.options = data?.options || {}
    state.baseCreditHistory.filter.countries = data?.filter?.countries || []
  },
  setHostessCancelledToValidated (state, data) {
    state.baseHostessCancelledToValidated.chart.percent = data?.chart?.percent || []
    state.baseHostessCancelledToValidated.chart.cancelled = data?.chart?.cancelled || []
    state.baseHostessCancelledToValidated.chart.validated = data?.chart?.validated || []
    state.baseHostessCancelledToValidated.avg = data?.avg || []
    state.baseHostessCancelledToValidated.options = data?.options || {}
    state.baseHostessCancelledToValidated.filter.countries = data?.filter?.countries || []
  },
  setTurnover (state, value) {
    state.turnover = prepareTurnoverData(value.data, this.$config?.currencySign || '$')
    state.turnoverTime = value.meta?.time
  },
  setClientTotals (state, value) {
    state.clientTotals = prepareClientTotalsData(value.data)
    state.clientTotalsTime = value.meta?.time
  },
  setTwoDaysTotal (state, value) {
    state.twoDaysTotal = prepareTotalsData(value, this.$config?.currencySign || '$')
  },
  setTwoDaysChart (state, value) {
    state.twoDaysChart = prepareChartData(value, this.$config?.currencySign || '$')
  },
  setSevenDaysTotal (state, value) {
    state.sevenDaysTotal = prepareTotalsData(value, this.$config?.currencySign || '$')
  },
  setSevenDaysChart (state, value) {
    state.sevenDaysChart = prepareChartData(value, this.$config?.currencySign || '$')
  },
  setThirtyDaysTotal (state, value) {
    state.thirtyDaysTotal = prepareTotalsData(value, this.$config?.currencySign || '$')
  },
  setThirtyDaysChart (state, value) {
    state.thirtyDaysChart = prepareChartData(value, this.$config?.currencySign || '$')
  },
  setMonthlyTotal (state, { year, month, data }) {
    state[`monthlyTotal${year}${month}`] = prepareTotalsData(data, this.$config?.currencySign || '$')
  },
  setMonthlyChart (state, { year, month, data }) {
    state[`monthlyChart${year}${month}`] = prepareChartData(data, this.$config?.currencySign || '$')
  },
  setUserStatConfirmed (state, data) {
    state.userStatConfirmed.chart = data?.chart || []
    state.userStatConfirmed.avg = data?.avg || []
    state.userStatConfirmed.options = data?.options || {}
    state.userStatConfirmed.filter.countries = data?.filter?.countries || []
    state.userStatConfirmed.filter.campaigns = data?.filter?.campaigns || []
  },
  setUserStatFreeLikes (state, data) {
    state.userStatFreeLikes.chart = data?.chart || []
    state.userStatFreeLikes.avg = data?.avg || []
    state.userStatFreeLikes.options = data?.options || {}
    state.userStatFreeLikes.filter.countries = data?.filter?.countries || []
    state.userStatFreeLikes.filter.campaigns = data?.filter?.campaigns || []
  },
  setUserStatPerspective (state, data) {
    state.userStatPerspective.chart = data?.chart || []
    state.userStatPerspective.avg = data?.avg || []
    state.userStatPerspective.options = data?.options || {}
    state.userStatPerspective.filter.countries = data?.filter?.countries || []
    state.userStatPerspective.filter.campaigns = data?.filter?.campaigns || []
  },
  setUserStatLids (state, data) {
    state.userStatLids.chart = data?.chart || []
    state.userStatLids.options = data?.options || {}
    state.userStatLids.filter.countries = data?.filter?.countries || []
    state.userStatLids.filter.campaigns = data?.filter?.campaigns || []
  },
  setUserStatKpiClients (state, data) {
    state.userStatKpiClients.chart = data?.chart || {}
    state.userStatKpiClients.options = data?.options || {}
    state.userStatKpiClients.filter.countries = data?.filter?.countries || []
    state.userStatKpiClients.filter.campaigns = data?.filter?.campaigns || []
    state.userStatKpiClients.avg = data?.avg || []
  },
  setUserStatKpiHostess (state, data) {
    state.userStatKpiHostess.chart = data?.chart || {}
    state.userStatKpiHostess.options = data?.options || {}
    state.userStatKpiHostess.filter.countries = data?.filter?.countries || []
    state.userStatKpiHostess.filter.campaigns = data?.filter?.campaigns || []
    state.userStatKpiHostess.avg = data?.avg || []
  },
  setClientLeave (state, data) {
    state.baseClientLeave.chart = data?.chart || []
    state.baseClientLeave.options = data?.options || {}
    state.baseClientLeave.filter.countries = data?.filter?.countries || []
  },
  setHostessLeave (state, data) {
    state.baseHostessLeave.chart = data?.chart || []
    state.baseHostessLeave.options = data?.options || {}
    state.baseHostessLeave.filter.countries = data?.filter?.countries || []
  },
  setClientLeaveItems (state, data) {
    state.baseClientLeave.items = data?.data || []
  },
  setHostessLeaveItems (state, data) {
    state.baseHostessLeave.items = data?.data || []
  }
}

export const getters = {
  getField,
  turnover (state) {
    return state.turnover
  },
  turnoverTime (state) {
    return state.turnoverTime
  },
  clientTotals (state) {
    return state.clientTotals
  },
  clientTotalsTime (state) {
    return state.clientTotalsTime
  },
  twoDaysTotal (state) {
    return state.twoDaysTotal
  },
  twoDaysChart (state) {
    return state.twoDaysChart
  },
  sevenDaysTotal (state) {
    return state.sevenDaysTotal
  },
  sevenDaysChart (state) {
    return state.sevenDaysChart
  },
  thirtyDaysTotal (state) {
    return state.thirtyDaysTotal
  },
  thirtyDaysChart (state) {
    return state.thirtyDaysChart
  },
  monthlyTotal: state => ({ year, month }) => {
    return state[`monthlyTotal${year}${month}`]
  },
  monthlyChart: state => ({ year, month }) => {
    return state[`monthlyChart${year}${month}`]
  },
  baseFreeUnlockedChart (state) {
    return state.baseFreeUnlocked.chart
  },
  baseFreeUnlockedAvg (state) {
    return state.baseFreeUnlocked.avg
  },
  baseFreeUnlockedOptions (state) {
    return state.baseFreeUnlocked.options
  },
  baseFreeUnlockedFilterCountries (state) {
    return state.baseFreeUnlocked.filter.countries
  },
  baseRevenueChart (state) {
    return state.baseRevenue.chart
  },
  baseRevenueAvg (state) {
    return state.baseRevenue.avg
  },
  baseRevenueOptions (state) {
    return state.baseRevenue.options
  },
  baseRevenueFilterCountries (state) {
    return state.baseRevenue.filter.countries
  },
  baseHostessDeletedChart (state) {
    return state.baseHostessDeleted.chart
  },
  baseHostessDeletedAvg (state) {
    return state.baseHostessDeleted.avg
  },
  baseHostessDeletedOptions (state) {
    return state.baseHostessDeleted.options
  },
  baseHostessDeletedFilterCountries (state) {
    return state.baseHostessDeleted.filter.countries
  },
  baseHostessValidatedChart (state) {
    return state.baseHostessValidated.chart
  },
  baseHostessValidatedAvg (state) {
    return state.baseHostessValidated.avg
  },
  baseHostessValidatedOptions (state) {
    return state.baseHostessValidated.options
  },
  baseHostessValidatedFilterCountries (state) {
    return state.baseHostessValidated.filter.countries
  },
  basePrimeHistoryChart (state) {
    return state.basePrimeHistory.chart
  },
  basePrimeHistoryAvg (state) {
    return state.basePrimeHistory.avg
  },
  basePrimeHistoryOptions (state) {
    return state.basePrimeHistory.options
  },
  basePrimeHistoryFilterCountries (state) {
    return state.basePrimeHistory.filter.countries
  },
  creditHistoryChart (state) {
    return state.baseCreditHistory.chart
  },
  creditHistoryAvg (state) {
    return state.baseCreditHistory.avg
  },
  creditHistoryOptions (state) {
    return state.baseCreditHistory.options
  },
  creditHistoryFilterCountries (state) {
    return state.baseCreditHistory.filter.countries
  },
  hostessCancelledToValidatedChart (state) {
    return state.baseHostessCancelledToValidated.chart
  },
  hostessCancelledToValidatedAvg (state) {
    return state.baseHostessCancelledToValidated.avg
  },
  hostessCancelledToValidatedOptions (state) {
    return state.baseHostessCancelledToValidated.options
  },
  hostessCancelledToValidatedFilterCountries (state) {
    return state.baseHostessCancelledToValidated.filter.countries
  },
  clientsLeaveChart (state) {
    return state.baseClientLeave.chart
  },
  clientsLeaveOptions (state) {
    return state.baseClientLeave.options
  },
  clientsLeaveFilterCountries (state) {
    return state.baseClientLeave.filter.countries
  },
  clientsLeaveItems (state) {
    return state.baseClientLeave.items
  },
  hostessLeaveChart (state) {
    return state.baseHostessLeave.chart
  },
  hostessLeaveOptions (state) {
    return state.baseHostessLeave.options
  },
  hostessLeaveFilterCountries (state) {
    return state.baseHostessLeave.filter.countries
  },
  hostessLeaveItems (state) {
    return state.baseHostessLeave.items
  },
  kpiClientsChart (state) {
    return state.userStatKpiClients.chart
  },
  kpiClientsOptions (state) {
    return state.userStatKpiClients.options
  },
  kpiClientsFilterCountries (state) {
    return state.userStatKpiClients.filter.countries
  },
  kpiClientsFilterCampaigns (state) {
    return state.userStatKpiClients.filter.campaigns
  },
  kpiClientsAvg (state) {
    return state.userStatKpiClients.avg
  },
  kpiHostessChart (state) {
    return state.userStatKpiHostess.chart
  },
  kpiHostessOptions (state) {
    return state.userStatKpiHostess.options
  },
  kpiHostessFilterCountries (state) {
    return state.userStatKpiHostess.filter.countries
  },
  kpiHostessFilterCampaigns (state) {
    return state.userStatKpiHostess.filter.campaigns
  },
  kpiHostessAvg (state) {
    return state.userStatKpiHostess.avg
  },

  userStatConfirmedChart (state) {
    return state.userStatConfirmed.chart || []
  },
  userStatConfirmedAvg (state) {
    return state.userStatConfirmed.avg || []
  },
  userStatConfirmedOptions (state) {
    return state.userStatConfirmed.options || {}
  },
  userStatConfirmedFilterCountries (state) {
    return state.userStatConfirmed.filter.countries || []
  },
  userStatConfirmedFilterCampaigns (state) {
    return state.userStatConfirmed.filter.campaigns || []
  },
  userStatFreeLikesChart (state) {
    return state.userStatFreeLikes.chart || []
  },
  userStatFreeLikesAvg (state) {
    return state.userStatFreeLikes.avg || []
  },
  userStatFreeLikesOptions (state) {
    return state.userStatFreeLikes.options || {}
  },
  userStatFreeLikesFilterCountries (state) {
    return state.userStatFreeLikes.filter.countries || []
  },
  userStatFreeLikesFilterCampaigns (state) {
    return state.userStatFreeLikes.filter.campaigns || []
  },
  userStatPerspectiveChart (state) {
    return state.userStatPerspective.chart || []
  },
  userStatPerspectiveAvg (state) {
    return state.userStatPerspective.avg || []
  },
  userStatPerspectiveOptions (state) {
    return state.userStatPerspective.options || {}
  },
  userStatPerspectiveFilterCountries (state) {
    return state.userStatPerspective.filter.countries || []
  },
  userStatPerspectiveFilterCampaigns (state) {
    return state.userStatPerspective.filter.campaigns || []
  },
  userStatLidsChart (state) {
    return state.userStatLids.chart
  },
  userStatLidsOptions (state) {
    return state.userStatLids.options
  },
  userStatLidsFilterCountries (state) {
    return state.userStatLids.filter.countries
  },
  userStatLidsFilterCampaigns (state) {
    return state.userStatLids.filter.campaigns || []
  }
}
